module.exports = __webpack_public_path__ + "img/VK.a483eedf.svg";